import { render } from "./PrevisioneTable.vue?vue&type=template&id=afdaea28&ts=true"
import script from "./PrevisioneTable.vue?vue&type=script&lang=ts"
export * from "./PrevisioneTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__